module.exports = __webpack_public_path__ + "img/SC-PROOF-5799.412e9075.png";